import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from '../../../services/shared/local-storage.service';
 
@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent implements OnInit {
  @Input() showLanguage = false;

  public lang: string = "en";
  currentLanguage: string;
  cssFile: any;
  cssFileAr: any;
  languageList = [
    { code: 'en', label: 'English' },
    { code: 'ar', label: 'Arabic' },
    { code: 'es', label: 'Spain' },
    { code: 'fr', label: 'French' }
  ];
  constructor(public translate: TranslateService, private localStorageService: LocalStorageService) {
    this.lang = this.localStorageService.GetItem('lang');
     
    if (this.lang == null) {
      this.localStorageService.SetItem('lang', "en");
      this.lang = this.localStorageService.GetItem('lang') as string;
    }
    translate.setDefaultLang(this.lang);
    this.translate.use(this.lang);

    let htmlTag = document.getElementsByTagName('html')[0] as HTMLHtmlElement;
    this.currentLanguage = htmlTag.lang.valueOf();

    this.setHtmlang(this.lang);
    this.changCssFile(this.lang);}

  ngOnInit(): void {
  }
  // #region methods
  changeLanguage(language: string) {
    this.localStorageService.SetItem('lang', language);
    window.location.reload();
  }

  changCssFile(lang) {
    if (this.currentLanguage != lang) {
      const cssFile = document.getElementById('style.bundle.css') as HTMLLinkElement
      const bundleCssFile = lang == 'en' ? './assets/css/style.bundle.css' : './assets/css/style.bundle.rtl.css'

      if (cssFile)
        cssFile.href = bundleCssFile;
    }
  }


  setHtmlang(lang) {
    if (this.currentLanguage != lang) {
      let htmlTag = document.getElementsByTagName('html')[0] as HTMLHtmlElement;
      if (lang == "en")
        htmlTag.lang = "en";
      else if (lang == "ar")
        htmlTag.lang = "ar";
    }
  }
  // #endregion
}
